/**
 * chartDataCache — in-memory cache of the last successful query result
 * for each saved DashboardItem (chart / metric).
 *
 * `PlotlyChartCard` and `MetricCard` populate the cache after their
 * mount-time SQL fetch; `ChartEditorPanel` reads from it when opened
 * to edit, so the editor can show the already-fetched data without
 * issuing another query.
 *
 * The cache is intentionally simple (no TTL, no LRU): chart cards
 * already gate their own fetch on `(item.id, item.sql_query)`, so
 * stale entries are overwritten the next time a card mounts. The
 * editor's "Run" button will always re-issue a fresh query if the
 * user wants to refresh.
 */

const _cache = new Map();

export function setChartData(itemId, payload) {
  if (itemId == null || !payload) return;
  _cache.set(String(itemId), {
    columns: payload.columns || [],
    rows: payload.rows || [],
    ts: Date.now(),
  });
}

export function getChartData(itemId) {
  if (itemId == null) return null;
  return _cache.get(String(itemId)) || null;
}

export function clearChartData(itemId) {
  if (itemId == null) { _cache.clear(); return; }
  _cache.delete(String(itemId));
}
